import AssignmentOutlined from '@mui/icons-material/AssignmentOutlined';
import LinkedIn from '@mui/icons-material/LinkedIn';
import NotesOutlined from '@mui/icons-material/NotesOutlined';
import SettingsOutlined from '@mui/icons-material/SettingsOutlined';
import { Avatar, Box, Card, Chip, Tab, Tabs, Typography, capitalize, useMediaQuery } from '@mui/material';
import moment from "moment";
import "moment/locale/fr";
import React, { useEffect, useState } from "react";
import Loader from "../../../components/Loader/Loader";
import TabPanelTaches from "../../../components/TabPanelTaches/TabPanelTaches";
import { TABLE } from "../../../enums/tablesEnum";
import { getDetails } from "../../../services/CandidatService";
import { deleteTacheCandidat, getAll, getAllTachesFaites } from "../../../services/TacheCandidatService";
import { withSnackbar } from "../../../utils/SnackbarHOC";
import { theme } from "../../../utils/Theme";
import "../../Contact/VisualiserContact/icons.css";
import Notes from "./Tabs/Notes";
import Process from "./Tabs/Process";
import "./visuialisation.css";

function TabPanel({ children, value, index, ...other }) {
  return (
    <div role="tabpanel" hidden={value !== index} id={`drawer-tabpanel-${index}`} aria-labelledby={`drawer-tab-${index}`} {...other}>
      {value === index && <Box className="candidate-drawer-panelInner">{children}</Box>}
    </div>
  );
}

const displayValue = (value) => ([null, undefined, "", "null"].includes(value) ? "-" : value);
const moneyValue = (value, unit = "€") => value !== null && value !== undefined && value !== 0 ? `${value} ${unit}` : "-";

const InfoTile = ({ label, value, link }) => (
  <div className="candidate-drawer-infoTile">
    <span>{label}</span>
    <strong>
      {link ? (
        <a href={link} target="_blank" rel="noreferrer">
          <LinkedIn fontSize="small" />
        </a>
      ) : (
        displayValue(value)
      )}
    </strong>
  </div>
);

const Section = ({ title, children, compact }) => (
  <section className={`candidate-drawer-card ${compact ? "candidate-drawer-cardCompact" : ""}`}>
    <h3 className="candidate-drawer-sectionTitle">{title}</h3>
    {children}
  </section>
);

function VisualiserCandidatDrawer({ snackbarShowMessage, idCandidat }) {
  const idSelectionDefaut = idCandidat;
  const [candidatDetails, setCandidatDetails] = useState({});
  const [loading, setLoading] = useState(true);
  const [value, setValue] = useState(0);
  const [nom, setNom] = useState("");
  const [prenom, setPrenom] = useState("");
  const [email, setEmail] = useState("");
  const [loadData, setLoadData] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isTalentManager, setIsTalentManager] = useState(false);
  const props = { loadData, setLoadData, snackbarShowMessage, deleteTache: deleteTacheCandidat, getAll, getAllTachesFaites, idCandidat: idSelectionDefaut, tacheFrom: TABLE.CANDIDAT };
  const isSmMode = useMediaQuery(theme.breakpoints.between(0, 480));

  function getUserData() {
    return JSON.parse(localStorage.getItem("userData"));
  }

  useEffect(() => {
    const userRole = getUserData()?.role;
    setIsAdmin(Boolean(userRole?.includes('ROLE_DIRECTION')));
    setIsTalentManager(Boolean(userRole?.includes('ROLE_TALENT_MANAGER')));
  }, []);

  useEffect(() => {
    let active = true;
    (async () => {
      setLoading(true);
      try {
        const params = idSelectionDefaut ? `?selection=${idSelectionDefaut}` : "";
        const candidat = await getDetails(idSelectionDefaut, params);
        if (!active) return;
        setCandidatDetails(candidat.data);
        setNom(candidat.data.nom);
        setPrenom(candidat.data.prenom);
        setEmail(candidat.data.email);
      } catch (err) {
        snackbarShowMessage("Erreur de chargement du candidat.", "error", 4000);
      } finally {
        if (active) setLoading(false);
      }
    })();

    return () => {
      active = false;
    };
  }, [idSelectionDefaut, snackbarShowMessage]);

  const handleTabs = (_event, newValue) => setValue(newValue);

  const fullName = `${displayValue(candidatDetails.titre)} ${displayValue(candidatDetails.nom)} ${displayValue(candidatDetails.prenom)}`.replace(/\s+/g, " ").trim();
  const initials = `${candidatDetails.prenom?.[0] || ""}${candidatDetails.nom?.[0] || ""}`.toUpperCase() || "CD";
  const lifecycleDate = candidatDetails.updatedAt
    ? `Mis à jour : ${moment(candidatDetails.updatedAt).locale("fr").format("DD MMMM YYYY - HH:mm")}`
    : `Créé le : ${moment(candidatDetails.createdAt).locale("fr").format("DD MMMM YYYY - HH:mm")}`;

  const mainInfo = [
    { label: "Téléphone", value: candidatDetails.telephone },
    { label: "Email", value: email },
    { label: "LinkedIn", value: "Profil", link: candidatDetails.linkedin },
    {
      label: "Delivery Manager",
      value: candidatDetails.accountManager ? `${candidatDetails.accountManager.prenom} ${candidatDetails.accountManager.nom}` : "-",
    },
    {
      label: "Talent Manager",
      value: candidatDetails.consultant ? `${candidatDetails.consultant.prenom} ${candidatDetails.consultant.nom}` : "-",
    },
    {
      label: "Sourceur",
      value: candidatDetails.sourceur ? `${candidatDetails.sourceur.prenom} ${candidatDetails.sourceur.nom}` : "-",
    },
    { label: "Société", value: candidatDetails.employeur ? candidatDetails.employeur.nomSociete.toUpperCase() : "-" },
    { label: "Fonction", value: candidatDetails.fonction },
    { label: "Seniorité", value: candidatDetails.dateDebutExperience ? candidatDetails.seniorite : "-" },
    { label: "Disponibilité", value: candidatDetails.preAvis || "-" },
    {
      label: "Date dispo.",
      value: !(['null', null, ''].includes(candidatDetails.dispoLe)) ? moment(candidatDetails.dispoLe).format("DD/MM/yyyy") : "-",
    },
  ];

  const moneySections = [
    {
      title: "Net mensuel actuel",
      rows: [
        { label: "Package", value: moneyValue(candidatDetails.actuellePackage) },
        { label: "Fixe", value: moneyValue(candidatDetails.actuelleFixe) },
      ],
    },
    {
      title: "Net mensuel souhaité",
      rows: [
        { label: "Package", value: moneyValue(candidatDetails.souhaitePackage) },
        { label: "Fixe", value: moneyValue(candidatDetails.souhaiteFixe) },
      ],
    },
  ];

  const tabs = [
    { name: "NOTES", icon: <NotesOutlined /> },
    { name: "TÂCHES", icon: <AssignmentOutlined /> },
    { name: "PROCESS", icon: <SettingsOutlined /> },
  ];

  const panels = [
    { index: 0, component: <Notes {...props} /> },
    { index: 1, component: <TabPanelTaches disableTableBodyMax={true} {...props} /> },
    {
      index: 2,
      component: (
        <Process
          {...props}
          candidatName={capitalize(prenom) + " " + nom}
          candidatEmail={candidatDetails.email}
          candidatTel={candidatDetails.telephone}
          candidatAccountManager={candidatDetails.accountManager}
          candidatConsultant={candidatDetails.consultant}
          candidatSeniorite={candidatDetails.seniorite}
          candidatCommentaire={candidatDetails.commentaire}
          candidatPointFort={candidatDetails.pointsforts}
          candidatSoftskills={candidatDetails.softskills}
          candidatFrancais={candidatDetails.francais}
          candidatAnglais={candidatDetails.anglais}
          candidatActuPackage={candidatDetails.actuellePackage}
          candidatActuFixe={candidatDetails.actuelleFixe}
          candidatActuVariable={candidatDetails.actuelleVariable}
          candidatActuInteress={candidatDetails.actuelleInteressement}
          candidatSouhaitePackage={candidatDetails.souhaitePackage}
          candidatsouhaiteFixe={candidatDetails.souhaiteFixe}
          candidatsouhaiteVariable={candidatDetails.souhaiteVariable}
          candidatsouhaiteInteress={candidatDetails.souhaiteInteress}
          candidatpreAvis={candidatDetails.preAvis}
          candidatdispoLe={candidatDetails.dispoLe}
          numCandidat={candidatDetails.numCandidat}
          processId={candidatDetails.processId}
        />
      ),
    },
  ];

  return (
    <Box className="candidate-drawer-view">
      {loading ? (
        <Loader />
      ) : (
        <>
          <header className="candidate-drawer-heroPro">
            <Avatar className="candidate-drawer-avatar">{initials}</Avatar>
            <div className="candidate-drawer-heroMain">
              <Typography className="candidate-drawer-name">{fullName}</Typography>
              <div className="candidate-drawer-meta">
                <Chip label={`N° ${displayValue(candidatDetails.numCandidat)}`} />
                <span>{lifecycleDate}</span>
              </div>
            </div>
          </header>

          <div className="candidate-drawer-scroll">
            <Section title="Informations">
              <div className="candidate-drawer-infoGrid">
                {mainInfo.map((item) => <InfoTile key={item.label} {...item} />)}
              </div>
            </Section>

            {(isAdmin || isTalentManager) && (
              <div className="candidate-drawer-moneyGrid">
                {moneySections.map((section) => (
                  <Section key={section.title} title={section.title} compact>
                    {section.rows.map((row) => (
                      <InfoTile key={row.label} label={row.label} value={row.value} />
                    ))}
                  </Section>
                ))}
              </div>
            )}

            <section className="candidate-drawer-workArea">
              <Box className="candidate-drawer-tabsBar">
                <Tabs
                  value={value}
                  onChange={handleTabs}
                  orientation="horizontal"
                  variant="fullWidth"
                  TabIndicatorProps={{ style: { backgroundColor: "white" } }}
                >
                  {tabs.map((tab) => (
                    <Tab
                      key={tab.name}
                      label={(
                        <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                          {tab.icon}
                          {!isSmMode && <span>{tab.name}</span>}
                        </Box>
                      )}
                    />
                  ))}
                </Tabs>
              </Box>
              <div className="candidate-drawer-tabPanel">
                {panels.map(({ index, component }) => (
                  <TabPanel key={index} value={value} index={index}>
                    {component}
                  </TabPanel>
                ))}
              </div>
            </section>
          </div>
        </>
      )}
    </Box>
  );
}

export default withSnackbar(VisualiserCandidatDrawer);
